<template>
  <div class="chat-room-wrapper">
    <div class="chat-list-loading" v-if="!dataDone"><van-loading type="spinner" size="14px">正在加载中...</van-loading></div>
    <div class="chat-list" v-else>
      <div class="list-container" v-if="chatList.length > 0">
        <router-link class="chat-item" tag="div" v-for="item in chatList" v-if="item.multipartData" :key="item.targetId" :to="{name: 'PatientChatRoom', params: {id: item.targetId}}">
          <div class="doctor-card" >
            <div class="doc-info">
              <div class="avatar">
                <div class="avatar-box"><img :src="item.multipartData.avatar" alt=""></div>
                <span class="notice-dot" v-if="item.unreadMessageCount > 0"></span>
              </div>
              <div class="info-text">
                <div class="name"><span class="doc-name">{{item.multipartData.username}}</span><span class="doc-title">{{item.multipartData.title | jobTitleFilter}}</span></div>
                <div class="department">{{item.multipartData.p_dep_title}} | {{item.multipartData.dep_title}}</div>
              </div>
              <span class="status-tip ing" v-if="item.multipartData.enroll.status == 3">诊疗中</span>
              <span class="status-tip booked" v-if="item.multipartData.enroll.status == 1">已预约</span>
              <span class="status-tip waitting" v-if="item.multipartData.enroll.status == 2">待诊疗</span>
            </div>
            <div class="last-message">
              <div class="last-info">
                <div class="type">上一条信息</div>
                <div class="last-time">{{item.latestMessage.sentTime | chatTimeFilter}}</div>
              </div>
              <div class="message">
                <span v-if="item.latestMessage.messageType == 'TextMessage'">{{item.latestMessage.content.content}}</span>
                <span v-else-if="item.latestMessage.messageType == 'ImageMessage'">[图片]</span>
                <span v-else-if="item.latestMessage.messageType == 'VoiceMessage'">[语音]</span>
                <span v-else-if="item.latestMessage.objectName == 'AnswerMsg'">[问诊单]</span>
                <span v-else-if="item.latestMessage.objectName == 'PreMsg'">[处方]</span>
                <span v-else-if="item.latestMessage.objectName == 'ReferMsg'">[转诊单]</span>
                <span v-else-if="item.latestMessage.messageType == 'CommandNotificationMessage' && item.latestMessage.content.name == 'FinishChat'">系统消息：本次诊疗已结束</span>
                <span v-else-if="item.latestMessage.messageType == 'CommandNotificationMessage' && item.latestMessage.content.name == 'OrderedChat'">
                  <!-- 预约诊疗文案 -->
                  <span v-if="item.latestMessage.content.data.type == 1">已预约{{item.latestMessage.content.data.startTime | dateFilter('month')}} - {{item.latestMessage.content.data.endTime | timeFilter}}的诊疗日程</span>
                  <span v-if="item.latestMessage.content.data.type == 2">实时问诊发起成功</span>
                </span>
                <span v-else>[未知类型消息]</span>
              </div>
            </div>
          </div>
          <div class="status booking" v-if="item.multipartData.enroll.type == 1">
            <div class="status-text">预约复诊时间：{{item.multipartData.enroll.start_time | dateFilter('month')}} - {{item.multipartData.enroll.end_time | timeFilter}}</div>
          </div>
          <div class="status live" v-if="item.multipartData.enroll.type == 2">
            <div class="status-text">实时问诊：{{item.multipartData.enroll.start_time | dateFilter('month')}} - {{item.multipartData.enroll.end_time | dateFilter('month')}}</div>
          </div>
        </router-link>

      </div>
      <!-- 空数据状态 -->
      <div class="empty-list" v-else>
        <icon icon-class="empty-room-doctor"></icon>
        <p>记得按时复诊哟</p>
        <button class="view-doctor" @click="viewDoctor">查看我的医生</button>
      </div>
    </div>
    <!-- <button @click="sendMessage">发一条消息</button>
    <button @click="sendImage">发一张图片</button> -->
    <!-- <router-link to="/patient/questionnaire">写个问诊单</router-link> -->
  </div>
</template>

<style lang="less" scoped>
  .chat-room-wrapper{

    height: 100%;
    overflow-y: auto;
    padding:0px 0px 40px 0px;

    .chat-list-loading{
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 23px;
    }
    .list-container{
      padding: 16px;
      .chat-item{
        margin-bottom: 12px;
        .doctor-card{
          position: relative;
          background: #FFF;
          padding: 0 16px;
          border-radius: 6px;
          box-shadow: 0px 4px 20px 0px rgba(0,0,0,0.1);
          z-index: 11;
          .doc-info{
            position: relative;
            padding: 16px 0 11px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            border-bottom: 1px solid #EEE;
            .avatar{
              position: relative;
              flex-shrink: 0;
              .avatar-box{
                width: 44px;
                height: 44px;
                border-radius: 50%;
                overflow: hidden;
                display: flex;
                justify-content: center;
                align-items: center;
                img{
                  width: 100%;
                }
              }
              .notice-dot{
                position: absolute;
                top: 0;
                right: 0;
                z-index: 1;
                width: 10px;
                height: 10px;
                border: 2px solid #FFF;
                background: @error;
                border-radius: 50%;
              }
            }
            .info-text{
              margin-left: 16px;
              flex: 1;
              padding-right: 50px;
              .name{
                font-size: 16px;
                line-height: 18px;
                color: @black;
                display: flex;
                justify-content: flex-start;
                align-items: baseline;
                span.doc-name{
                  max-width: 50%;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                }
                span.doc-title{
                  margin-left: 8px;
                  color: #999;
                  font-size: 14px;
                  font-weight: normal;
                }
              }
              .department{
                margin-top: 8px;
                font-size: 14px;
                line-height: 14px;
                color: #666;
              }
            }
            .status-tip{
              position: absolute;
              top: 16px;
              right: 0;
              font-size: 13px;
              line-height: 20px;
              white-space: nowrap;
              &::after{
                content: '';
                position: absolute;
                left: -9px;
                top: 50%;
                transform: translateY(-50%);
                width: 5px;
                height: 5px;
                border-radius: 50%;
              }
              &.booked{
                color: #E2AD2E;
                &::after{
                  background: #E2AD2E;
                }
              }
              &.ing{
                color: #00848A;
                &::after{
                  background: #00848A;
                }
              }
              &.waitting{
                color: @xile;
                &::after{
                  background: @xile;
                }
              }
            }
          }
          .last-message{
            height: 64px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            .last-info{
              display: flex;
              justify-content: space-between;
              align-items: center;
              font-size: 13px;
              line-height: 17px;
              color: #999;
            }
            .message{
              margin-top: 5px;
              font-size: 14px;
              line-height: 16px;
              color: @black;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              span{
                font-size: 14px;
                line-height: 14px;
              }
            }
          }
        }
        .status{
          position: relative;
          border-radius: 6px;
          background: rgba(54, 104, 166, 0.06);
          color: #666;
          padding: 6px 17px 0;
          margin-top: -6px;
          font-weight: normal;
          z-index: 10;
          &.live{
            background: rgba(54, 104, 166, 0.06);
          }
          .status-text{
            position: relative;
            font-size: 14px;
            line-height: 32px;
            padding-left: 9px;
            &::after{
              content: '';
              position: absolute;
              left: 0;
              top: 50%;
              transform: translateY(-50%);
              width: 2px;
              height: 12px;
              background: @xile;
            }
          }
        }
      }
    }
    .chat-list{
      padding-top: 4px;
      .empty-list{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 156px;
        svg{
          font-size: 72px;
          color: #DDD;
        }
        p{
          margin-top:12px;
          font-size: 15px;
          line-height: 15px;
          color: #CCC;
        }
        .view-doctor{
          @button-base();
          @button-border();
          margin-top: 40px;
          width: 200px;
          height: 38px;
        }
      }
    }
  }
</style>

<script type="text/javascript">
  export default {
    data() {
      return {
        dataDone: false,
        // 聊天类型
        conversationType: RongIMLib.ConversationType.PRIVATE,
        // 聊天信息发送的目标id
        targetId: '',
        // 聊天列表
        chatList: [],
      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      }
    },
    created() {
      let _this = this;
      let conversationTypes = [ RongIMLib.ConversationType.PRIVATE ];
      let count = 150;
      // 更新聊天列表数据
      RongIMClient.getInstance().getConversationList({
        onSuccess(list) {
          console.log(list);
          _this.$store.commit('setChatList', list);
          _this.chatList = _this.$store.state.chatList;
          if(list && list.length > 0) {
            let doctorList = [];
            list.forEach(item => {
              doctorList.push(item.targetId);
              RongIMClient.getInstance().getUnreadCount(_this.conversationType, item.targetId, {
                onSuccess(count) {
                  console.log(count)
                }
              })
            })
            _this.$root.post('/getDoctorList', {
              pat_id: _this.userInfo.user_id,
              doc_id: doctorList
            }).then(data => {
              // 混合数据
                    console.log('混合数据')
              console.log(data)
              _this.chatList.forEach((item, index) => {
                data.forEach(stuff => {
                  if(parseInt(item.targetId) == parseInt(stuff.user_id)) {
                    _this.$set(item, 'multipartData', stuff);
                  }
                })
              })
              console.log(_this.chatList)
              _this.dataDone = true;
            })
          }else {
            _this.dataDone = true;
          }
        }
      }, conversationTypes, count)
      // 获取会话
      let messageListener = {
        onReceived(message) {
          switch(message.messageType){
            case RongIMClient.MessageType.TextMessage: {
              console.log(message.content.content + 'after')
            }break;
          }
        }
      }
    },
    methods: {
      viewDoctor() {
        this.$router.push('/patient/doctor');
      },
    },
    filters: {
      chatTimeFilter(time) {
        // 如果是当天返回时间，如果不是当天返回相对时间
        if(moment().isSame(time, 'day')) {
          return moment(time).format('HH:mm');
        }else {
          return moment(time).fromNow()
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Patient/Index/chatRoom.vue